import { render, staticRenderFns } from "./ParentEditStory.vue?vue&type=template&id=5b8e1e2c&scoped=true&"
import script from "./ParentEditStory.vue?vue&type=script&lang=js&"
export * from "./ParentEditStory.vue?vue&type=script&lang=js&"
import style0 from "./ParentEditStory.vue?vue&type=style&index=0&id=5b8e1e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e1e2c",
  null
  
)

export default component.exports